export const environment = {
    production: false,
    apiUrl: 'https://dev.five.awl.org.au',
    env: 'Development',
    googleApiKey: 'AIzaSyCPCqPGsZsMJRDO9vcLgIeP0TcNZJJOxug',
};
